import { useQuery } from '@tanstack/react-query';
import iotApi from 'lib/api/iotApi.client';
import { ClientQueryKey } from './client.hooks.keys';

export function useGetAllClients(params: { keyword?: string }) {
  const { keyword } = params;

  return useQuery({
    queryKey: [ClientQueryKey.GET_ALL_CLIENTS, keyword],
    queryFn: async () => {
      const res = await iotApi.client.getAllClients({ keyword });

      return res.data;
    },
  });
}
